import React, { useEffect } from "react";
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import "./Expenses.css";
import { AbstructVar } from "../../../components/general/general-component/abstruct-component/AbstructVar";
import { AbstructLang } from "../../../components/general/general-component/abstruct-component/AbstructLang";
import { useSelectorCustom } from "../../../components/general/general-component/abstruct-component/useSelectorCustom";
import {
  emptyOneExpense,
  loadOneExpense,
} from "../../../store/Actions/ActionExpenses";
import moment from "moment";
import { formatNumberWithCommas } from "../../../components/general/general-component/abstruct-component/FunctionRemoveCommas";

function DetailsExpenses({ expense_id, open, setOpen }) {
  const { dispatch, langLocal, navigate } = AbstructVar();
  const { translate } = AbstructLang();
  const { one_expense, loadingOneExpense, currency } = useSelectorCustom();
  useEffect(() => {
    dispatch(loadOneExpense(expense_id));
  }, []);

  return (
    <RModal
      open={open}
      onClose={() => {
        setOpen(false);
        dispatch(emptyOneExpense());
      }}
      center
      classNames={{
        modal: `pop_details_expenses`,
      }}
      focusTrapped={false}
      overlayOpacity={0.5}
    >
      <div
        className="div-details-expenses"
        dir={langLocal == "ar" ? "rtl" : "ltr"}
      >
        <div className="images-details-expenses">
          <img
            src={
              one_expense?.invoice_image
                ? one_expense?.invoice_image
                : one_expense?.delivery_receipt_image
            }
          />
        </div>
        <div className="info-details-expenses">
          <div className="div-one-expenses">
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses title-one-expenses`}
            >
              {translate("invoice_number")}
            </span>
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses1 sub-title-one-expenses`}
            >
              {one_expense?.invoice_number}
            </span>
          </div>
          <div className="div-one-expenses">
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses title-one-expenses`}
            >
              {translate("date")}
            </span>
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses1 sub-title-one-expenses`}
            >
              {moment(one_expense?.date).format("YYYY-MM-DD")}
            </span>
          </div>
          <div className="div-one-expenses">
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses title-one-expenses`}
            >
              {translate("created_by")}
            </span>
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses1 sub-title-one-expenses`}
            >
              {one_expense?.created_by?.name}
            </span>
          </div>
          <div className="div-one-expenses">
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses title-one-expenses`}
            >
              {translate("created_at")}
            </span>
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses1 sub-title-one-expenses`}
            >
              {moment(one_expense?.created_at).format("YYYY-MM-DD")}
            </span>
          </div>
          <div className="div-one-expenses">
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses title-one-expenses`}
            >
              {translate("description")}
            </span>
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses1 sub-title-one-expenses`}
            >
              {one_expense?.descriptions}
            </span>
          </div>
          <div className="div-one-expenses">
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses title-one-expenses`}
            >
              {translate("additional_notes")}
            </span>
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses1 sub-title-one-expenses`}
            >
              {one_expense?.notes}
            </span>
          </div>

          <div className="div-one-expenses">
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses title-one-expenses`}
            >
              {translate("amount")}
            </span>
            <span
              className={` ${
                langLocal === "ar" ? "textAlignRight" : ""
              } span-one-expenses1 sub-title-one-expenses`}
            >
              {formatNumberWithCommas(one_expense?.amount)}{" "}
              {translate(currency)}
            </span>
          </div>
          {one_expense?.revolving && (
            <div className="div-one-expenses">
              <span
                className={`${
                  langLocal === "ar" ? "textAlignRight" : ""
                } span-one-expenses title-one-expenses`}
              >
                {translate("remaining_amount")}
              </span>
              <span
                className={`${
                  langLocal === "ar" ? "textAlignRight" : ""
                } span-one-expenses1 sub-title-one-expenses`}
              >
                {formatNumberWithCommas(one_expense?.remaining_amount)}{" "}
                {translate(currency)}
              </span>
            </div>
          )}
        </div>
      </div>
    </RModal>
  );
}

export default DetailsExpenses;
